import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function ContainerDetailsTable(props) {
  const { data, onAddContainerDetails, onEditContainerDetails, onDeleteContainerDetails, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)

  const containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_NUMBER)
  const containerSize = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_SIZE)
  const sealIdentifier = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SEAL_IDENTIFIER)
  const cargoType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CARGO_TYPE)

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddContainerDetails}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Container
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{containerNumber}</TableCell>
              <TableCell>{containerSize}</TableCell>
              <TableCell>{sealIdentifier}</TableCell>
              <TableCell>{cargoType}</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.containerNumber}</TableCell>
                <TableCell>{item.containerSize}</TableCell>
                <TableCell>{item.sealIdentifier}</TableCell>
                <TableCell>{item.cargoType}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEditContainerDetails(item)}>
                      <FontAwesomeIcon icon={['fal', 'pen']} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => onDeleteContainerDetails(item)}>
                      <FontAwesomeIcon icon={['fal', 'trash']} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default ContainerDetailsTable
